/**
 * GlobalFooter – site-wide footer with copyright, Help (optional), and Privacy Policy.
 * Uses Agent UI design system tokens and link/accessibility guidelines.
 * When onOpenPrivacy is provided, Privacy Policy opens in-app; otherwise links to /privacy.html.
 */
export default function GlobalFooter({ onOpenPrivacy, onOpenHelp }) {
  const year = new Date().getFullYear()

  return (
    <footer
      className="global-footer"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className="global-footer-inner">
        <p className="global-footer-copyright">
          © {year} Captain Cook
        </p>
        <nav className="global-footer-links" aria-label="Help and legal">
          {typeof onOpenHelp === 'function' ? (
            <button
              type="button"
              onClick={onOpenHelp}
              className="global-footer-link link-cta link-cta-inline"
              aria-label="Help"
            >
              Help
            </button>
          ) : null}
          {onOpenPrivacy ? (
            <button
              type="button"
              onClick={onOpenPrivacy}
              className="global-footer-link link-cta link-cta-inline"
              aria-label="View privacy policy"
            >
              Privacy Policy
            </button>
          ) : (
            <a
              href="/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="global-footer-link link-cta link-cta-inline"
              aria-label="View privacy policy (opens in new tab)"
            >
              Privacy Policy
            </a>
          )}
        </nav>
      </div>
    </footer>
  )
}
